import { instantToCivil, monthName, type CalendarSystem, type Lang } from "@calendar/shared";
import { n, stamp } from "../format.js";

interface Props {
  results: Awaited<ReturnType<typeof import("../api.js").api.searchNotes>>["items"];
  query: string;
  timeZone: string;
  calendar: CalendarSystem;
  lang: Lang;
  t: (key: string, vars?: Record<string, string | number>) => string;
  onSearch: (query: string) => void;
  onOpen: (id: string) => void;
}

export function SearchPanel(props: Props) {
  const { results, query, timeZone, calendar, lang, t, onSearch, onOpen } = props;

  return (
    <>
      <div className="toolbar">
        <input
          className="input"
          style={{ maxWidth: 420 }}
          value={query}
          placeholder={t("search.placeholder")}
          onChange={(e) => onSearch(e.target.value)}
          autoFocus
        />
      </div>

      <div className="list">
        {results.length === 0 ? (
          <p className="muted center">{query ? t("empty.noResults") : t("search.placeholder")}</p>
        ) : (
          results.map((e) => {
            const c = instantToCivil(e.startUtc, timeZone, calendar);
            const when = stamp(e.startUtc, timeZone, calendar, lang);
            return (
              <div className="list__row" key={e.id} onClick={() => onOpen(e.id)}>
                <span className="list__time">
                  {n(`${c.date.day} ${monthName(c.date.month, calendar, lang)}`, lang)}
                  <br />
                  {e.allDay ? t("field.allDay") : when.time}
                </span>
                <span>
                  <span className="list__title">{e.title}</span>
                  {e.location && <span className="muted"> · {e.location}</span>}
                  <div className="list__notes">{e.notes}</div>
                </span>
              </div>
            );
          })
        )}
      </div>
    </>
  );
}
